import React, { createContext, useState, useEffect } from 'react';
import { auth, provider, signInWithPopup, signOut } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import NavBar from '../NavBar';
import Landing from '../pages/Landing';
import axios from 'axios';
import ClipLoader from 'react-spinners/ClipLoader';
import CONFIG from '../config.js';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fetchData, setFetchData] = useState({});
    const [isAdmin, setIsAdmin] = useState(false);
    const verifyWindowLocation = (location) => {
        const url = window.location.href;
        return url.includes(location);
    }
    const [showNavLinks, setShowNavLinks] = useState(false);
    const [adminSelectedUser, setAdminSelectedUser] = useState();
    const url = CONFIG.createUrl();

    const config = {headers: CONFIG.HEADERS};

    // Monitor auth state on component mount
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                try {
                    const response = await axios.get(`${url}user/profile?email=${user.email}`, config);
                    if (response.data.type === "admin") {
                        setIsAdmin(true);
                        if (verifyWindowLocation("profile")) {
                            navigate('/profile');
                        } else {
                            navigate('/adminHome');
                        }
                    } else {
                        setShowNavLinks(true);
                    }
                    setUser(response.data); // User is signed in, set user details in state
                } catch (err) {
                    await signOut(auth);
                    setUser(null);
                    if (err.status === 404) {
                        setLoading(false);
                        console.log(err);
                    }
                    console.log(err);
                } finally {
                    setLoading(false);
                }
            } else {
                setUser(null); // User is signed out
            }
            setLoading(false);
        });

        // Cleanup the listener on unmount
        return () => unsubscribe();
    }, [setUser]);

    const handleGoogleSignIn = () => {
        setLoading(true);
        signInWithPopup(auth, provider)
            .then((result) => {
                verifyUser(result.user);
            })
            .catch((error) => {
                console.error('Error during sign-in:', error);
            });
    };

    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                navigate('/');
                setUser(null);
                setFetchData({});
            })
            .catch((error) => {
                console.error('Error during sign-out:', error);
            });
    };

    const verifyUser = async (userData) => {
        try {
            const response = await axios.get(`${url}user/profile?email=${userData.email}`, config);
            setUser(response.data);
            if (response.data.type === "admin") {
                setIsAdmin(true);
                navigate('/adminHome');
            } else {
                navigate('/home');
            }
        } catch (err) {
            await signOut(auth);
            setUser(null);
            if (err.status === 404) {
                setLoading(false);
                console.log(err);
            }
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <div>
            <NavBar />
            <div className="spinner-container">
                <ClipLoader color={"#123abc"} loading={loading} size={50} />
            </div>
        </div>;
    }

    return (
        <AuthContext.Provider value={{
            user,
            handleGoogleSignIn,
            handleLogout,
            fetchData,
            setFetchData,
            loading,
            setLoading,
            showNavLinks,
            setShowNavLinks,
            isAdmin,
            adminSelectedUser,
            setAdminSelectedUser
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;